import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';

class LoaderButton extends Component {
  render() {
    const {
      requesting,
      label = 'Submit',
      raised = true,
      onClick
    } = this.props;
    const ButtonComponent = raised ? RaisedButton : FlatButton;
    return (
      <ButtonComponent
        label={requesting ? '' : label}
        icon={
          requesting ? <CircularProgress size={25} thickness={2} /> : <span />
        }
        onClick={onClick}
        primary={true}
        disabled={requesting}
        style={{
          margin: '10px 0px',
          position: 'relative'
        }}
      />
    );
  }
}
LoaderButton.propTypes = {
  label: PropTypes.string,
  raised: PropTypes.bool,
  onClick: PropTypes.func,
  requesting: PropTypes.bool
};
export default LoaderButton;



// WEBPACK FOOTER //
// ./src/components/button/LoaderButton.js